import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Button,
  CircularProgress,
} from "@mui/material";
import { styled } from "@mui/system";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";
import apiClient from "../utils/apiClient";
import { toast } from "react-toastify";
import { getImageFullUrl } from "../utils/common";
import { useDispatch , useSelector } from "react-redux";

// Custom upload input (hidden)
const HiddenInput = styled("input")({
  display: "none",
});

const LogoManagement = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch()
  const logo = useSelector((state) => state.logo);

  // ✅ Upload Logo
  const handleUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!["image/jpeg", "image/jpg", "image/png", "image/webp"].includes(file.type)) {
      toast.error("Only JPG, PNG, or WEBP images are allowed!");
      return;
    }

    const formData = new FormData();
    formData.append("logo", file);

    try {
      setLoading(true);
     const res=  await apiClient.post("/api/logo", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success("Logo uploaded successfully!");
    //   fetchLogo();
    dispatch({ key: 'logo', value: res?.data?.data?.logoUrl || "", type: 'SET_VALUE' })

    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to upload logo");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Delete Logo
  const handleDelete = async () => {
    try {
      setLoading(true);
      await apiClient.delete(`/api/logo`);
      toast.success("Logo deleted successfully!");
      dispatch({ key: 'logo', value: "", type: 'SET_VALUE' })

    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to delete logo");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 500, mx: "auto", mt: 5 }}>
      <Typography variant="h5" sx={{ mb: 3, textAlign: "center" }}>
        Logo Management
      </Typography>

      <Card sx={{ p: 2, textAlign: "center", borderRadius: 3, boxShadow: 3 }}>
        {loading ? (
          <CircularProgress />
        ) : logo ? (
          <>
            <CardMedia
              component="img"
              image={getImageFullUrl( logo)}
              alt="Website Logo"
              sx={{ maxHeight: 150, objectFit: "contain", mb: 2 }}
            />
            <CardContent>
              <Typography variant="body2" sx={{ mb: 2 }}>
                Current Website Logo
              </Typography>

              <label htmlFor="upload-logo">
                <HiddenInput
                  accept="image/*"
                  id="upload-logo"
                  type="file"
                  onChange={handleUpload}
                />
                <Button
                  variant="contained"
                  component="span"
                  startIcon={<CloudUploadIcon />}
                  sx={{ mr: 2 }}
                >
                  Replace Logo
                </Button>
              </label>

              <Button
                variant="outlined"
                color="error"
                startIcon={<DeleteIcon />}
                onClick={handleDelete}
              >
                Delete Logo
              </Button>
            </CardContent>
          </>
        ) : (
          <Box>
            <Typography variant="body2" sx={{ mb: 2 }}>
              No logo uploaded yet
            </Typography>
            <label htmlFor="upload-logo">
              <HiddenInput
                accept="image/*"
                id="upload-logo"
                type="file"
                onChange={handleUpload}
              />
              <Button
                variant="contained"
                component="span"
                startIcon={<CloudUploadIcon />}
              >
                Upload Logo
              </Button>
            </label>
          </Box>
        )}
      </Card>
    </Box>
  );
};

export default LogoManagement;
